import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mogu-data';

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            <i className="ri-apps-2-line text-secondary-500 mr-2"></i>全部分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">探索蘑菇tv丰富多彩的内容分类</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group flex items-center gap-4 p-5 rounded-xl bg-background-100 hover:bg-secondary-50 border border-transparent hover:border-secondary-200 transition-all duration-200"
            >
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center group-hover:bg-secondary-200 transition-colors flex-shrink-0">
                <i className={`${category.icon} text-xl text-secondary-600`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{category.name}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{category.count}个直播间</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}